<div class="row">
    <p class="Breadcrumb mb-0">
        <a routerLink="/" class="active">{{'lang.common.home' | translate}} </a>
        <img src="./../../assets/images/logo/breadcumb-arrow.svg">
        <span> {{"lang.pricebandConfiguration.heading" | translate}} </span>
    </p>
    <h2 class="setting_name">
        <img src="./../../assets/images/scenerio-planner/back-arrow.svg" class="cursorPointer">
        {{"lang.pricebandConfiguration.heading" | translate}}
    </h2>
    <div class="setting">
        <table mat-table [dataSource]="dataSource" class="custom-table">

            <!-- Column 1 -->
            <ng-container matColumnDef="column1">
              <th mat-header-cell *matHeaderCellDef> {{"lang.pricebandConfiguration.spar_priceband" | translate}} </th>
              <td mat-cell *matCellDef="let element" class="price_band_data"> {{element?.geo_desc}} </td>
            </ng-container>
          
            <!-- Column 2 -->
            <ng-container matColumnDef="column2">
              <th mat-header-cell *matHeaderCellDef> {{"lang.pricebandConfiguration.elasticity_price_band" | translate}} </th>
              <td mat-cell *matCellDef="let element" class="price_band_data"> 
                <p-dropdown [options]="price_band_data" [disabled]="!utilService.isAccessAvailable('dynamic_price_band') || element.is_elasticity_available"  [(ngModel)]="element.geo_elasticity_destination_id" (onChange)="OnPriceBandChange(element)" dataKey="geo_source_id" appendTo="body"
                optionLabel="geo_desc" optionValue="geo_source_id" placeholder="{{ 'lang.pricebandConfiguration.dropdown_placeholder' | translate }}" class="language font-md" placeholder="Select Price Band">
                </p-dropdown>
              </td>
            </ng-container>
          
            <!-- Header and Row definitions -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>      
          <div *ngIf="utilService.isAccessAvailable('dynamic_price_band')" class="action_buttons">
            <button class="cancel" (click)="onCancel()">{{"lang.common.cancel" | translate}}</button>
            <button class="save" [disabled]="!save_configuration.length" [ngClass]="{is_disable: !save_configuration.length}" (click)="onSavePriceBandConfiguration()">{{"lang.common.save" | translate}}</button>
          </div>    
    </div>
</div>
